import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const CreateContactListProModal = ({ open, onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (name || "").trim();
    if (!trimmed) {
      toast.error("Informe o nome da lista.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/contact-lists-pro", { name: trimmed });
      toast.success("Lista criada com sucesso!");
      onClose();
      if (onSuccess) onSuccess(data);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Criar lista de contatos</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Nome da lista"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Ex: Clientes 2025"
            variant="outlined"
            margin="normal"
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading || !(name || "").trim()}
          >
            {loading ? "Criando..." : "Criar lista"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateContactListProModal;
